import React from 'react';
import Dropdown from '@prisjakt/ui-dropdown';

import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

import { SortInfo } from '../../../../types';
import { Sort } from '../sharedTypes';

type Props = {
  onSelect: (sort: { name: string; value: Sort }) => void;
  sortOptions?: string[];
  sort: SortInfo;
};

class SortButton extends React.PureComponent<Props> {
  defaultOption() {
    const translationString = `sort.${this.props.sort.name}:${this.props.sort.direction}`;
    const option = this.context.t('common', translationString);

    if (option === translationString) {
      return this.context.t('common', `sort.${this.props.sort.name}`);
    }

    return option;
  }

  sortOptions() {
    return (
      this.props.sort.available &&
      this.props.sort.available
        .filter(x => x !== this.props.sort.name)
        .filter(
          x => x !== `${this.props.sort.name}:${this.props.sort.direction}`
        )
        .map(option => ({
          name: this.context.t('common', `sort.${option}`),
          value: option,
        }))
        .filter(x => x.name !== `sort.${x.value}`)
    );
  }

  render() {
    if (!this.props.sort.available || this.props.sort.available.length <= 1) {
      return null;
    }

    return (
      <S.SortButton>
        <Dropdown
          width="100%"
          options={this.sortOptions()}
          selected={this.defaultOption()}
          onSelect={this.props.onSelect}
        />
      </S.SortButton>
    );
  }
}

SortButton.contextType = AppContext;

export default SortButton;
